import { Box, List } from "@saleor/macaw-ui-next";

import { useMenuStructure } from "./hooks/useMenuStructure";
import { MenuItem } from "./Item";

export const Menu = () => {
  const menuStructure = useMenuStructure();

  return (
    <Box
      padding={3}
      overflowY="auto"
      overflowX="hidden"
      className="hide-scrollbar"
      display="flex"
      flexDirection="column"
    >
      <List as="ol" display="grid" gap={2} data-test-id="menu-list">
        {menuStructure.map(menuItem => (
          <MenuItem menuItem={menuItem} key={menuItem.id} />
        ))}
      </List>
    </Box>
  );
};
